import { render, staticRenderFns } from "./UmoviDostavku.vue?vue&type=template&id=c800eea2&scoped=true&"
var script = {}
import style0 from "./UmoviDostavku.vue?vue&type=style&index=0&id=c800eea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c800eea2",
  null
  
)

export default component.exports